<script>
import { required } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import Middleware from "@/helpers/middlewares";

import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      floor: {
        name: "",
        short_name: "",
        building: "",
        edit: false,
        image: null,
      },
      buildingOptions: [],
      imgURL: "",
      submitted: false,
      is_btn_loading: false,
      isSaveAndAddNew: false,
      imagePreView: [],
      imageToSubmit: [],
      isImageUploading: false,
      editId: null,
    };
  },
  components: {
    VueDropify,
    draggable,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  validations: {
    floor: {
      name: {
        required,
      },
      short_name: {
        required,
      },
      building: {
        required,
      },
    },
  },
  mounted() {
    this.setIfEdit();
    this.getBuildListData();
  },
  methods: {
    getBuildListData() {
      UserService.getBuildingList()
        .then((response) => {
          response.map((item) => {
            this.buildingOptions.push({
              text: item.short_name + "-" + item.name,
              value: item.id,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    setIfEdit() {
      if (this.currentProps.isEdit) {
        this.editId = this.currentProps.selectedFloor.id;
        this.floor.name = this.currentProps.selectedFloor.name;
        this.floor.short_name = this.currentProps.selectedFloor.short_name;
        this.floor.building = this.currentProps.selectedFloor.building.id;
        this.imagePreView = this.currentProps.selectedFloor.floor_image;
      }
    },
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
        };
        data = { ...data, ...this.floor };
        if (this.currentProps.isEdit == false) {
          UserService.createFloor(data)
            .then(
              (floor) => {
                let floor_image = [];
                if (this.imageToSubmit.length !== 0) {
                  this.imageToSubmit.map((image, index) => {
                    let floorImage = new FormData();
                    floorImage.append("floor", floor.id);
                    floorImage.append("image", image);
                    if (index == 0) {
                      floorImage.append("is_thumbnail", true);
                      floorImage.append("is_floor_plan", true);
                    }
                    UserService.addPhotoToFloor(floor.id, floorImage)
                      .then((floorImages) => {
                        this.$root.$emit("imageAddedInFloor", floorImages);
                        floor_image.push(floorImages);
                        this.isBtnLoading = false;
                        this.submitted = false;
                      })
                      .catch((error) => {
                        errorHandler(error);
                      });
                  });
                } else {
                  this.isBtnLoading = false;
                  this.submitted = false;
                }
                if (this.isSaveAndAddNew) {
                  this.$emit("saveAndAddNew", { ...floor, floor_image });
                  this.floor = {
                    name: "",
                    short_name: "",
                    building: "",
                    edit: false,
                  };
                } else {
                  this.$emit("submitted", { ...floor, floor_image });
                }
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          UserService.editFloor(data, this.currentProps.selectedFloor.id)
            .then(
              (floor) => {
                this.$emit("submitted", floor);
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new floor continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new floor
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    //Method is use for change image as thumbnail image
    changeThumbnailImageStatus(image, status) {
      const imageData = new FormData();
      let imageStatus =
        status == "is_thumbnail" ? image.is_thumbnail : image.is_floor_plan;
      imageData.append(status, imageStatus);
      UserService.updatePhotoToFloor(image.floor, image.id, imageData).then(
        (response) => {
          this.$root.$emit("updateImageStatusInFloor", response);
          this.imagePreView = this.imagePreView.map((image) => {
            if (image.id !== response.id) {
              if (status == "is_thumbnail") {
                image = { ...image, is_thumbnail: false };
              } else {
                image = { ...image, is_floor_plan: false };
              }
            } else {
              if (status == "is_thumbnail") {
                image = { ...image, is_thumbnail: true };
              } else {
                image = { ...image, is_floor_plan: true };
              }
            }
            return image;
          });
          Middleware.notification(
            "Thumbnail image successfully set !!",
            "success"
          );
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    // Method is use for delete image
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deletePhotoToFloor(image.floor, image.id).then(
            () => {
              this.$root.$emit("removeImageInFloor", this.imagePreView[index]);
              this.imagePreView.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "success");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is use for maintained change image event
    changeFloorImage(event) {
      const imgURL = event[0] == undefined ? null : event[0];
      if (imgURL !== null && this.currentProps.isEdit) {
        this.isImageUploading = true;
        let floorImageData = new FormData();
        floorImageData.append("floor", this.editId);
        floorImageData.append("image", imgURL);
        UserService.addPhotoToFloor(this.editId, floorImageData).then(
          (floorImages) => {
            this.imagePreView.push(floorImages);
            setTimeout(() => {
              document.querySelector(".has-icon").click();
            }, 500);
          },
          (error) => {
            this.isImageUploading = false;
            errorHandler(error);
          }
        );
      } else {
        if (imgURL !== null) {
          this.imageToSubmit.push(imgURL);
          let image = window.URL.createObjectURL(event[0]);
          this.imagePreView.push({
            image,
            id: this.imageToSubmit.length,
            is_thumbnail: false,
            priority_order: this.imageToSubmit.length,
          });
          this.floor.image = null;
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        }
      }
    },
    // Method is use for change floor image
    onChoose: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updatePhotoToFloor(
        evt.moved.element.floor,
        evt.moved.element.id,
        imageData
      )
        .then(() => {
          Middleware.notification("Image position changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ this.currentProps.isEdit ? "Update" : "Add New" }} Floor</h4>
        <hr />

        <div class="row">
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Name" label-for="floor">
              <template slot="label">
                Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="floor"
                type="text"
                autocomplete="off"
                placeholder="Ex : Floor Name"
                v-model="floor.name"
                :class="{
                  'is-invalid': submitted && $v.floor.name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.floor.name.required"
                  >Floor name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3"
              label="Short Code"
              label-for="short_code"
            >
              <template slot="label">
                Short Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="short_code"
                type="text"
                autocomplete="off"
                placeholder="Ex : Floor Short Name"
                v-model="floor.short_name"
                :class="{
                  'is-invalid': submitted && $v.floor.short_name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.floor.short_name.required"
                  >Floor short name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              label="Building"
              label-for="building"
            >
              <template slot="label">
                Building <span class="text-danger">*</span>
              </template>
              <b-form-select
                class="form-select"
                id="building"
                type="text"
                autocomplete="off"
                v-model="floor.building"
                :options="buildingOptions"
                :class="{
                  'is-invalid': submitted && $v.floor.building.$error,
                }"
              >
              </b-form-select>
              <div
                v-if="submitted && $v.floor.building.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.floor.building.required"
                  >Build is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <label for="Image">
              <span slot="label">Image</span>
            </label>
            <draggable
              class="row"
              v-model="imagePreView"
              v-bind="dragOptions"
              @change="onChoose"
              :disabled="!currentProps.isEdit"
            >
              <div
                class="col-md-3"
                v-for="(image, index) in imagePreView"
                :key="index"
              >
                <div class="d-flex align-items-start mb-3">
                  <div>
                    <img
                      class="rounded object-fit common-upload-img-size"
                      alt="room_type_image"
                      :src="
                        typeof image.image !== null || '' ? image.image : ''
                      "
                      :id="image.id"
                      data-holder-rendered="true"
                      :class="currentProps.isEdit ? 'cursor-move' : ''"
                    />
                  </div>
                  <div class="ms-2" v-if="currentProps.isEdit">
                    <div class="form-check">
                      <input
                        :disabled="
                          imagePreView.length == 1 && image.is_thumbnail
                        "
                        class="form-check-input"
                        type="checkbox"
                        :id="image.is_thumbnail"
                        v-model="image.is_thumbnail"
                        v-b-popover.hover="'Use as Thumbnail image'"
                        @change="
                          changeThumbnailImageStatus(image, 'is_thumbnail')
                        "
                      />
                    </div>
                    <div class="form-check">
                      <input
                        :disabled="
                          imagePreView.length == 1 && image.is_floor_plan
                        "
                        class="form-check-input"
                        type="checkbox"
                        :id="image.is_floor_plan"
                        v-model="image.is_floor_plan"
                        v-b-popover.hover="'Use as Floor Plan Image'"
                        @change="
                          changeThumbnailImageStatus(image, 'is_floor_plan')
                        "
                      />
                    </div>
                    <i
                      class="mdi mdi-trash-can fs-5 text-danger"
                      v-if="
                        imagePreView.length !== 1 &&
                        !image.is_thumbnail &&
                        !image.is_floor_plan
                      "
                      slot="label"
                      v-b-popover.hover="'Delete Image'"
                      @click="deleteImage(image, index)"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="col-md-3" draggable="true" v-if="!isImageUploading">
                <div class="position-relative plus-icon">
                  <VueDropify
                    @upload="changeFloorImage($event)"
                    :src="floor.image"
                    accept="image/png, image/svg, image/jpg, image/jpeg"
                    message="Drop image or click here to select"
                    height="150px"
                    id="infoServices_images"
                    class="mb-3"
                  />
                  <i class="bx bx-plus fs-1"></i>
                </div>
              </div>
              <div class="col-md-3 placeholder-glow" v-else>
                <p
                  class="placeholder placeholder-lg common-upload-img-size"
                ></p>
              </div>
            </draggable>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              v-if="this.currentProps.isEdit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{
                disabled: isSaveAndAddNew === true && is_btn_loading,
              }"
            >
              <i
                v-if="isSaveAndAddNew === true && is_btn_loading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isSaveAndAddNew === false && is_btn_loading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isSaveAndAddNew === false && is_btn_loading"
              ></i>
              {{ this.currentProps.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
